import tw from "twin.macro";
import styled from "styled-components";

type PProps = { 
    id?: string;
    className?: string;
    children?:any;
};

const StyledText = styled.p<PProps>`
  ${tw`font-semibold text-gray-600`}
`;

const Text = ({className, children, ...rest}:PProps) => {
    return(
        <StyledText className={className} {...rest}>
            {children}
        </StyledText>
    )
}

export default Text;


